module.exports = __webpack_public_path__ + "static/media/tablet.e7410c2b.svg";